let allPrices = document.querySelectorAll('.frequency__selector-label-price span[data-variant-price]');

const applySubscriptionDiscount = () => {
  allPrices.forEach(price => {
    let newPrice;
    
    if (document.querySelector('#main-prodct-form input#purchase_type').value == 'subscription'){
      newPrice = parseFloat(price.dataset.variantSubscriptionPrice).toFixed(2);
    }else if(document.querySelector('#main-prodct-form input#purchase_type').value == 'onetimer'){
      newPrice = parseFloat(price.dataset.variantPrice).toFixed(2);
    }

    price.textContent = newPrice;
  });
}

const updateMainPrice = () => {
  let newPrice;
  if (document.querySelector('#main-prodct-form input#purchase_type')) {
    if (document.querySelectorAll('.dynamic-price-to-update')){
      document.querySelectorAll('.dynamic-price-to-update').forEach(dynamic_price => {
        if (document.querySelector('#main-prodct-form input#purchase_type').value == 'subscription'){
            newPrice = parseFloat(dynamic_price.dataset.variantSubscriptionPrice).toFixed(2);
        }else{
        newPrice =  parseFloat(dynamic_price.dataset.variantOriginalPrice).toFixed(2);
        }

        dynamic_price.innerHTML = newPrice;
      });
    }
  }

}

const updateUnitPrice = () => {
  let base_prices = document.querySelectorAll('.base__price') || false;
  if (base_prices.length > 0) {
    base_prices.forEach(el => {
      //If any variant is selected
      if (location.search.length > 0){
        if (location.search.indexOf(el.dataset.variant) > -1 && el.dataset.type ==  document.querySelector('product-form input[name="properties[_purchase_type]"]').value){
          el.classList.add('active');
        }else{
          el.classList.remove('active');
        }
      }
    });
  }
}


//Price Update for variant picker
document.body.addEventListener('productVariantUpdated', applySubscriptionDiscount);
document.addEventListener('DOMContentLoaded', applySubscriptionDiscount);

//Main price update on pagelaod and type select
document.addEventListener('DOMContentLoaded', updateMainPrice);
document.body.addEventListener('productVariantUpdated', updateMainPrice);

//Update price per unit (per 1kg)
document.body.addEventListener('productVariantUpdated', updateUnitPrice);